export default {
  order_status_toast: {
    order_reviewed: '#{{number}} O seu pedido foi visto',
    order_confirmed: '#{{number}} Hora confirmada {{time}}',
    order_preparation_up_time_changed: '#{{number}} Hora de {{type}} alterada para {{time}}',
    serving_time_changed: '#{{number}} O seu pedido será servido às {{time}}',
    order_preparing: 'O seu pedido #{{number}} está a ser preparado',
    order_rejected: 'Pedido #{{number}} rejeitado',
  },
  order_type: {
    pickup: 'Takeaway',
    delivery: 'Entrega',
  },
};
